import type { ReactElement } from 'react';

/**
 * The tags of a row, read-only.
 *
 * A component rather than three lines repeated in each row, because there are now
 * three places that show a tag and they have to look like the same thing: a todo,
 * a reminder, and whatever the next module is. The first copy that drifted would
 * be the one nobody compares.
 *
 * Nothing at all when there are none — an empty container still occupies the
 * margin above it, and a row with no tag would sit one line lower than it should.
 */
export function TagChips({ tags }: { tags: string[] }): ReactElement | null {
  if (tags.length === 0) return null;

  return (
    <span className="mt-1 flex flex-wrap items-center gap-1">
      {tags.map((tag) => (
        <span
          key={tag}
          className="rounded-full bg-accent-soft px-2 py-0.5 text-xs font-medium text-accent"
        >
          {tag}
        </span>
      ))}
    </span>
  );
}
